import { touchWebClient, webApiClient } from 'tradera-utils/http';

const createShipmentCheckout = async () =>
    webApiClient.post('/mytradera/shipmentcheckout/createshipmentcheckout');

const deleteShipment = async shipmentId =>
    touchWebClient.post('/my/shipping/checkout/delete', { shipmentId });

const getShippingOptions = (fromCountry, toCountry) =>
    webApiClient.get(
        `/selling/shipmentcheckout/shipping-products-for-country-by-weight-span?fromCountryCode=${fromCountry}&toCountryCode=${toCountry}`
    );

const setShipmentDetails = async payload =>
    webApiClient.post('/mytradera/shipmentcheckout/shipment', {
        shippingDetails: payload
    });

const setShippingAsBooked = async purchaseOrderId =>
    webApiClient.post('/member/selling/item-shipping-booked', {
        purchaseOrderId: purchaseOrderId,
        booked: true
    });

const setShippingAsShipped = async purchaseOrderId =>
    webApiClient.post('/member/selling/item-shipped', {
        purchaseOrderId: purchaseOrderId,
        shipped: true
    });

const getMemberSoldItemShippingInfo = purchaseOrderId =>
    webApiClient.get(
        `/member/selling/sold-item/shipping-info-v2/${purchaseOrderId}`
    );

export default {
    createShipmentCheckout,
    deleteShipment,
    getShippingOptions,
    setShipmentDetails,
    setShippingAsBooked,
    setShippingAsShipped,
    getMemberSoldItemShippingInfo
};
